import { render } from "./connect.vue?vue&type=template&id=d6020262"
import script from "./connect.vue?vue&type=script&lang=ts"
export * from "./connect.vue?vue&type=script&lang=ts"
script.render = render

export default script